import { render, staticRenderFns } from "./PieSectionPreview.vue?vue&type=template&id=a4fe7890&scoped=true&"
import script from "./PieSectionPreview.vue?vue&type=script&lang=js&"
export * from "./PieSectionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fe7890",
  null
  
)

export default component.exports